export type AlertLevelItem = {
  level: string;
  isActive: boolean;
  value: string;
};

export const initialAlertLevels: AlertLevelItem[] = [
  {
    level: "Acute",
    isActive: false,
    value: "PsnAcute",
  },
  {
    level: "Level 2",
    isActive: false,
    value: "PsnLevel2",
  },
  {
    level: "Level 3",
    isActive: false,
    value: "PsnLevel3",
  },
  {
    level: "Level 2 Acute",
    isActive: false,
    value: "PsnLevel2Acute",
  },
  {
    level: "Level 3 Acute",
    isActive: false,
    value: "PsnLevel3Acute",
  },
];

export const initialEscalatedAlertLevels: AlertLevelItem[] = [
  {
    level: "Level 3",
    isActive: false,
    value: "Level3",
  },
  {
    level: "Level 2",
    isActive: false,
    value: "Level2",
  },
  {
    level: "Level 1",
    isActive: false,
    value: "Level1",
  },
];
